import { Link, useNavigate } from "react-router-dom";
import { UnityLogo } from "../../assets/svgs";
import { useEffect, useState } from "react";
import hamburger from "../../assets/images/fillers/menu.svg";
import closeIcon from "../../assets/images/fillers/close.svg";

const Navbar = () => {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 80);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <nav className={`shadow-md fixed w-full top-0 z-20 transition-all duration-300 ${scrolled ? "py-2 bg-white/60 backdrop-blur-xl" : "bg-white/90 py-4"}`}>
                <div className="container mx-auto flex justify-between items-center px-6">
                    <div 
                        className="logoBox flex flex-row gap-2 items-center cursor-pointer transition-all duration-300"
                        onClick={() => navigate("/")}
                    >
                        <UnityLogo />
                        <h1 className={`text-2xl font-black text-[#302e24] font-montserrat whitespace-nowrap transition-all hidden md:block duration-300 ${scrolled ? "text-lg" : "text-2xl"}`}>
                            Unity Fabric Industries Ltd.
                        </h1>
                    </div>
                    <ul className="hidden lg:flex space-x-6">
                        <li><Link to="/" className="text-gray-600 text-sm hover:text-[#302e24] hover:underline duration-300 font-bold">Home</Link></li>
                        <li><Link to="/about" className="text-gray-600 text-sm hover:font-bold hover:text-[#302e24] hover:underline duration-500">About</Link></li>
                        <li><Link to="/awards" className="text-gray-600 text-sm hover:font-bold hover:text-[#302e24] hover:underline duration-500">Awards</Link></li>
                        <li><Link to="/products" className="text-gray-600 text-sm hover:font-bold hover:text-[#302e24] hover:underline duration-500">Products</Link></li>
                        <li><Link to="/partners" className="text-gray-600 text-sm hover:font-bold hover:text-[#302e24] hover:underline duration-500">Partners</Link></li>
                        <li><Link to="/sustainable-csr" className="text-gray-600 hover:font-bold text-sm hover:text-[#302e24] hover:underline duration-500">Sustainability & CSR</Link></li>
                    </ul>
                    <img src={hamburger} alt="menu" className="h-8 cursor-pointer lg:hidden" onClick={() => setMenuOpen(true)} />
                </div>
            </nav>
            
            {/* Overlay and Side Navbar */}
            {menuOpen && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-md z-30 flex">
                    <div className="bg-white w-64 h-full p-6 shadow-lg transform transition-transform duration-500 translate-x-0">
                        <button className="absolute top-4 right-4" onClick={() => setMenuOpen(false)}>
                            <img src={closeIcon} alt="close" className="h-6" />
                        </button>
                        <ul className="mt-12 space-y-4">
                            <li><Link to="/" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>Home</Link></li>
                            <li><Link to="/about" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>About</Link></li>
                            <li><Link to="/awards" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>Awards</Link></li>
                            <li><Link to="/products" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>Products</Link></li>
                            <li><Link to="/partners" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>Partners</Link></li>
                            <li><Link to="/sustainable-csr" className="text-gray-800 text-lg font-semibold" onClick={() => setMenuOpen(false)}>Sustainability & CSR</Link></li>
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;
